import { c as _c } from "react/compiler-runtime";
// Settings panels: Members (truss.Member: who is in this instance and its spaces, with which roles; add by name,
// remove) and Tokens (personal access tokens for the CLI and agents: create — the secret is shown once —, revoke at
// once). Shared pieces only (Group/Stack/Item, SectionHead, Field, LinkButton, Segmented, ErrorLine).
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { api, type Member, type Token } from "@/api";
import { useLoad } from "@/lib/load";
import { errorText } from "@/store";
import { ErrorLine } from "./error-line";
import { Field } from "./field";
import { Group, Item, Stack } from "./group";
import { Initials } from "./initials";
import { LinkButton } from "./link-button";
import { SectionHead } from "./section-head";
import { Loader } from "./loader";
import { Segment, Segmented } from "./segmented";
const day = (iso: string | null) => iso ? iso.slice(0, 10) : "—";
export function Members() {
  const $ = _c(108);
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      kinds: ["Member"]
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const members = useLoad(_temp, "members", t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      kinds: ["Role"]
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const roles = useLoad(_temp2, "roles", t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      kinds: ["Space"]
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const spaces = useLoad(_temp3, "spaces", t2);
  const [name, setName] = useState("");
  const [role, setRole] = useState("member");
  const [space, setSpace] = useState(null);
  const [error, setError] = useState(null);
  const [invite, setInvite] = useState(null);
  let t3;
  if ($[3] !== role || $[4] !== space) {
    t3 = async () => {
      if (!space) {
        return;
      }
      setError(null);
      setInvite(null);
      ;
      try {
        setInvite(await api.members.invite(space, [role]));
      } catch (t4) {
        const e = t4;
        setError(errorText(e));
      }
    };
    $[3] = role;
    $[4] = space;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const makeInvite = t3;
  let t4;
  if ($[6] !== members) {
    t4 = async fn => {
      setError(null);
      ;
      try {
        await fn();
        members.reload();
      } catch (t5) {
        const e_0 = t5;
        setError(errorText(e_0));
      }
    };
    $[6] = members;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const act = t4;
  let T0;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[8] !== act || $[9] !== members.data || $[10] !== members.loading || $[11] !== name || $[12] !== role || $[13] !== roles.data || $[14] !== space || $[15] !== spaces.data || $[16] !== t) {
    const active = (members.data ?? []).filter(_temp4);
    const scopes = [null, ...(spaces.data ?? []).filter(_temp5).map(_temp6)];
    const scopeName = id => id ? spaces.data?.find(s_1 => s_1.id === id)?.name ?? id : t("members.instance");
    const groups = scopes.map(s_2 => ({
      s: s_2,
      rows: active.filter(m_0 => (m_0.space?.id ?? null) === s_2)
    })).filter(_temp7);
    t11 = "members";
    if ($[28] !== members.loading) {
      t12 = <Loader on={members.loading} />;
      $[28] = members.loading;
      $[29] = t12;
    } else {
      t12 = $[29];
    }
    t13 = groups.map(g_0 => <div key={g_0.s ?? "instance"}><SectionHead>{scopeName(g_0.s)}</SectionHead><Group>{g_0.rows.map(m_1 => <Stack key={m_1.id} data-id={m_1.id} title={<span className="who-line"><Initials name={m_1.person.name} />{m_1.person.name}</span>} value={m_1.roles.includes("owner") ? <span className="muted">{m_1.roles.join(", ")}</span> : <LinkButton data-t="remove-member" onClick={() => void act(() => api.members.remove(m_1.id))}>{t("members.remove")}</LinkButton>} sub={m_1.roles.join(", ")} />)}</Group></div>);
    let t15;
    if ($[30] !== t) {
      t15 = t("members.add");
      $[30] = t;
      $[31] = t15;
    } else {
      t15 = $[31];
    }
    if ($[32] !== t15) {
      t14 = <SectionHead>{t15}</SectionHead>;
      $[32] = t15;
      $[33] = t14;
    } else {
      t14 = $[33];
    }
    if ($[34] !== act || $[35] !== name || $[36] !== role || $[37] !== space) {
      t8 = e_1 => {
        e_1.preventDefault();
        if (name.trim()) {
          act(() => api.members.add({
            name: name.trim()
          }, [role], space)).then(() => setName(""));
        }
      };
      $[34] = act;
      $[35] = name;
      $[36] = role;
      $[37] = space;
      $[38] = t8;
    } else {
      t8 = $[38];
    }
    let t16;
    if ($[39] !== t) {
      t16 = t("members.name");
      $[39] = t;
      $[40] = t16;
    } else {
      t16 = $[40];
    }
    let t17;
    if ($[41] !== t) {
      t17 = t("members.name");
      $[41] = t;
      $[42] = t17;
    } else {
      t17 = $[42];
    }
    let t18;
    if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = e_2 => setName(e_2.target.value);
      $[43] = t18;
    } else {
      t18 = $[43];
    }
    let t19;
    if ($[44] !== name) {
      t19 = name.trim();
      $[44] = name;
      $[45] = t19;
    } else {
      t19 = $[45];
    }
    const t20 = !t19;
    let t21;
    if ($[46] !== t) {
      t21 = t("members.addButton");
      $[46] = t;
      $[47] = t21;
    } else {
      t21 = $[47];
    }
    let t22;
    if ($[48] !== t20 || $[49] !== t21) {
      t22 = <LinkButton type="submit" disabled={t20}>{t21}</LinkButton>;
      $[48] = t20;
      $[49] = t21;
      $[50] = t22;
    } else {
      t22 = $[50];
    }
    if ($[51] !== name || $[52] !== t16 || $[53] !== t17 || $[54] !== t22) {
      t9 = <Field t="member-name" placeholder={t16} aria-label={t17} value={name} onChange={t18} action={t22} />;
      $[51] = name;
      $[52] = t16;
      $[53] = t17;
      $[54] = t22;
      $[55] = t9;
    } else {
      t9 = $[55];
    }
    let t23;
    if ($[56] !== t) {
      t23 = t("members.role");
      $[56] = t;
      $[57] = t23;
    } else {
      t23 = $[57];
    }
    let t24;
    if ($[58] !== roles.data) {
      t24 = roles.data ?? [];
      $[58] = roles.data;
      $[59] = t24;
    } else {
      t24 = $[59];
    }
    let t25;
    if ($[60] !== role || $[61] !== t24) {
      let t26;
      if ($[63] !== role) {
        t26 = r => <Segment key={r.id} pressed={role === r.name} onClick={() => setRole(r.name)}>{r.name}</Segment>;
        $[63] = role;
        $[64] = t26;
      } else {
        t26 = $[64];
      }
      t25 = t24.map(t26);
      $[60] = role;
      $[61] = t24;
      $[62] = t25;
    } else {
      t25 = $[62];
    }
    if ($[65] !== t23 || $[66] !== t25) {
      t10 = <Segmented t="member-role" label={t23}>{t25}</Segmented>;
      $[65] = t23;
      $[66] = t25;
      $[67] = t10;
    } else {
      t10 = $[67];
    }
    T0 = Segmented;
    t5 = "member-space";
    if ($[68] !== t) {
      t6 = t("members.space");
      $[68] = t;
      $[69] = t6;
    } else {
      t6 = $[69];
    }
    t7 = scopes.map(s_3 => <Segment key={s_3 ?? "instance"} pressed={space === s_3} onClick={() => setSpace(s_3)}>{scopeName(s_3)}</Segment>);
    $[8] = act;
    $[9] = members.data;
    $[10] = members.loading;
    $[11] = name;
    $[12] = role;
    $[13] = roles.data;
    $[14] = space;
    $[15] = spaces.data;
    $[16] = t;
    $[17] = T0;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    T0 = $[17];
    t10 = $[18];
    t11 = $[19];
    t12 = $[20];
    t13 = $[21];
    t14 = $[22];
    t5 = $[23];
    t6 = $[24];
    t7 = $[25];
    t8 = $[26];
    t9 = $[27];
  }
  let t15;
  if ($[70] !== T0 || $[71] !== t5 || $[72] !== t6 || $[73] !== t7) {
    t15 = <T0 t={t5} label={t6}>{t7}</T0>;
    $[70] = T0;
    $[71] = t5;
    $[72] = t6;
    $[73] = t7;
    $[74] = t15;
  } else {
    t15 = $[74];
  }
  const t16 = !space;
  let t17;
  if ($[75] !== makeInvite) {
    t17 = () => void makeInvite();
    $[75] = makeInvite;
    $[76] = t17;
  } else {
    t17 = $[76];
  }
  let t18;
  if ($[77] !== t) {
    t18 = t("members.invite");
    $[77] = t;
    $[78] = t18;
  } else {
    t18 = $[78];
  }
  let t19;
  if ($[79] !== t16 || $[80] !== t17 || $[81] !== t18) {
    t19 = <LinkButton data-t="invite-link" disabled={t16} onClick={t17}>{t18}</LinkButton>;
    $[79] = t16;
    $[80] = t17;
    $[81] = t18;
    $[82] = t19;
  } else {
    t19 = $[82];
  }
  let t20;
  if ($[83] !== space || $[84] !== t) {
    t20 = !space && <span className="muted">{t("members.inviteNeedsSpace")}</span>;
    $[83] = space;
    $[84] = t;
    $[85] = t20;
  } else {
    t20 = $[85];
  }
  let t21;
  if ($[86] !== t19 || $[87] !== t20) {
    t21 = <div className="flex items-center gap-3 py-2">{t19}{t20}</div>;
    $[86] = t19;
    $[87] = t20;
    $[88] = t21;
  } else {
    t21 = $[88];
  }
  let t22;
  if ($[89] !== invite) {
    t22 = invite && <div data-t="invite-url" className="mono select-all break-all py-1">{invite}</div>;
    $[89] = invite;
    $[90] = t22;
  } else {
    t22 = $[90];
  }
  let t23;
  if ($[91] !== t10 || $[92] !== t15 || $[93] !== t21 || $[94] !== t22 || $[95] !== t8 || $[96] !== t9) {
    t23 = <form onSubmit={t8}>{t9}{t10}{t15}{t21}{t22}</form>;
    $[91] = t10;
    $[92] = t15;
    $[93] = t21;
    $[94] = t22;
    $[95] = t8;
    $[96] = t9;
    $[97] = t23;
  } else {
    t23 = $[97];
  }
  let t24;
  if ($[98] !== error || $[99] !== members.error) {
    t24 = (error || members.error) && <ErrorLine>{error ?? members.error}</ErrorLine>;
    $[98] = error;
    $[99] = members.error;
    $[100] = t24;
  } else {
    t24 = $[100];
  }
  let t25;
  if ($[101] !== t11 || $[102] !== t12 || $[103] !== t13 || $[104] !== t14 || $[105] !== t23 || $[106] !== t24) {
    t25 = <div data-t={t11}>{t12}{t13}{t14}{t23}{t24}</div>;
    $[101] = t11;
    $[102] = t12;
    $[103] = t13;
    $[104] = t14;
    $[105] = t23;
    $[106] = t24;
    $[107] = t25;
  } else {
    t25 = $[107];
  }
  return t25;
}
function _temp7(g) {
  return g.rows.length;
}
function _temp6(s_0) {
  return s_0.id;
}
function _temp5(s) {
  return !s.instance;
}
function _temp4(m) {
  return m.status === "active";
}
function _temp3() {
  return api.chat.spaces();
}
function _temp2() {
  return api.members.roles();
}
function _temp() {
  return api.members.list();
}
export function Tokens() {
  const $ = _c(79);
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      kinds: ["Token"]
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const tokens = useLoad(_temp8, "tokens", t0);
  const [name, setName] = useState("");
  const [secret, setSecret] = useState(null);
  const [error, setError] = useState(null);
  let t1;
  if ($[1] !== name || $[2] !== tokens) {
    t1 = async () => {
      setError(null);
      ;
      try {
        const r = await api.tokens.create(name.trim());
        setSecret({
          name: r.token.name,
          value: r.secret
        });
        setName("");
        tokens.reload();
      } catch (t2) {
        const e = t2;
        setError(errorText(e));
      }
    };
    $[1] = name;
    $[2] = tokens;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const create = t1;
  let t2;
  if ($[4] !== t || $[5] !== tokens) {
    t2 = async tk => {
      if (!window.confirm(t("tokens.confirmRevoke", {
        name: tk.name
      }))) {
        return;
      }
      setError(null);
      ;
      try {
        await api.tokens.revoke(tk.id);
        tokens.reload();
      } catch (t3) {
        const e_0 = t3;
        setError(errorText(e_0));
      }
    };
    $[4] = t;
    $[5] = tokens;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const revoke = t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[7] !== create || $[8] !== name || $[9] !== revoke || $[10] !== secret || $[11] !== t || $[12] !== tokens.data || $[13] !== tokens.loading) {
    const live = (tokens.data ?? []).filter(_temp9);
    const revoked = (tokens.data ?? []).filter(_temp0);
    t3 = "tokens";
    if ($[21] !== tokens.loading) {
      t4 = <Loader on={tokens.loading} />;
      $[21] = tokens.loading;
      $[22] = t4;
    } else {
      t4 = $[22];
    }
    let t10;
    if ($[23] !== create || $[24] !== name) {
      t10 = e_1 => {
        e_1.preventDefault();
        if (name.trim()) {
          create();
        }
      };
      $[23] = create;
      $[24] = name;
      $[25] = t10;
    } else {
      t10 = $[25];
    }
    let t11;
    if ($[26] !== t) {
      t11 = t("tokens.new");
      $[26] = t;
      $[27] = t11;
    } else {
      t11 = $[27];
    }
    let t12;
    if ($[28] !== t11) {
      t12 = <SectionHead>{t11}</SectionHead>;
      $[28] = t11;
      $[29] = t12;
    } else {
      t12 = $[29];
    }
    let t13;
    if ($[30] !== t) {
      t13 = t("tokens.name");
      $[30] = t;
      $[31] = t13;
    } else {
      t13 = $[31];
    }
    let t14;
    if ($[32] !== t) {
      t14 = t("tokens.name");
      $[32] = t;
      $[33] = t14;
    } else {
      t14 = $[33];
    }
    let t15;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = e_2 => setName(e_2.target.value);
      $[34] = t15;
    } else {
      t15 = $[34];
    }
    let t16;
    if ($[35] !== name) {
      t16 = name.trim();
      $[35] = name;
      $[36] = t16;
    } else {
      t16 = $[36];
    }
    const t17 = !t16;
    let t18;
    if ($[37] !== t) {
      t18 = t("tokens.create");
      $[37] = t;
      $[38] = t18;
    } else {
      t18 = $[38];
    }
    let t19;
    if ($[39] !== t17 || $[40] !== t18) {
      t19 = <LinkButton type="submit" data-t="create-token" disabled={t17}>{t18}</LinkButton>;
      $[39] = t17;
      $[40] = t18;
      $[41] = t19;
    } else {
      t19 = $[41];
    }
    let t20;
    if ($[42] !== name || $[43] !== t13 || $[44] !== t14 || $[45] !== t19) {
      t20 = <Field t="token-name" className="mono" placeholder={t13} aria-label={t14} value={name} onChange={t15} action={t19} />;
      $[42] = name;
      $[43] = t13;
      $[44] = t14;
      $[45] = t19;
      $[46] = t20;
    } else {
      t20 = $[46];
    }
    if ($[47] !== t10 || $[48] !== t12 || $[49] !== t20) {
      t5 = <form onSubmit={t10}>{t12}{t20}</form>;
      $[47] = t10;
      $[48] = t12;
      $[49] = t20;
      $[50] = t5;
    } else {
      t5 = $[50];
    }
    if ($[51] !== secret || $[52] !== t) {
      t6 = secret && <div className="secret-once" data-t="token-secret"><div className="muted">{t("tokens.once", {
            name: secret.name
          })}</div><code className="mono">{secret.value}</code><LinkButton onClick={() => void navigator.clipboard?.writeText(secret.value)}>{t("tokens.copy")}</LinkButton><LinkButton onClick={() => setSecret(null)}>{t("panel.close")}</LinkButton></div>;
      $[51] = secret;
      $[52] = t;
      $[53] = t6;
    } else {
      t6 = $[53];
    }
    let t21;
    if ($[54] !== t) {
      t21 = t("tokens.active");
      $[54] = t;
      $[55] = t21;
    } else {
      t21 = $[55];
    }
    if ($[56] !== t21) {
      t7 = <SectionHead>{t21}</SectionHead>;
      $[56] = t21;
      $[57] = t7;
    } else {
      t7 = $[57];
    }
    let t22;
    if ($[58] !== revoke || $[59] !== t) {
      t22 = tk_0 => <Stack key={tk_0.id} data-id={tk_0.id} title={<span className="mono">{tk_0.name}</span>} value={<LinkButton data-t="revoke-token" onClick={() => void revoke(tk_0)}>{t("tokens.revoke")}</LinkButton>} sub={t("tokens.meta", {
        created: day(tk_0.createdAt),
        used: day(tk_0.lastUsedAt)
      })} />;
      $[58] = revoke;
      $[59] = t;
      $[60] = t22;
    } else {
      t22 = $[60];
    }
    const t23 = live.map(t22);
    let t24;
    if ($[61] !== live || $[62] !== t) {
      t24 = !live.length && <Item label={t("tokens.none")} value="" />;
      $[61] = live;
      $[62] = t;
      $[63] = t24;
    } else {
      t24 = $[63];
    }
    if ($[64] !== t23 || $[65] !== t24) {
      t8 = <Group>{t23}{t24}</Group>;
      $[64] = t23;
      $[65] = t24;
      $[66] = t8;
    } else {
      t8 = $[66];
    }
    t9 = revoked.length > 0 && <><SectionHead>{t("tokens.revoked")}</SectionHead><Group>{revoked.map(_temp1)}</Group></>;
    $[7] = create;
    $[8] = name;
    $[9] = revoke;
    $[10] = secret;
    $[11] = t;
    $[12] = tokens.data;
    $[13] = tokens.loading;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  let t10;
  if ($[67] !== error || $[68] !== tokens.error) {
    t10 = (error || tokens.error) && <ErrorLine>{error ?? tokens.error}</ErrorLine>;
    $[67] = error;
    $[68] = tokens.error;
    $[69] = t10;
  } else {
    t10 = $[69];
  }
  let t11;
  if ($[70] !== t10 || $[71] !== t3 || $[72] !== t4 || $[73] !== t5 || $[74] !== t6 || $[75] !== t7 || $[76] !== t8 || $[77] !== t9) {
    t11 = <div data-t={t3}>{t4}{t5}{t6}{t7}{t8}{t9}{t10}</div>;
    $[70] = t10;
    $[71] = t3;
    $[72] = t4;
    $[73] = t5;
    $[74] = t6;
    $[75] = t7;
    $[76] = t8;
    $[77] = t9;
    $[78] = t11;
  } else {
    t11 = $[78];
  }
  return t11;
}
function _temp1(tk_1) {
  return <Item key={tk_1.id} label={<span className="mono muted">{tk_1.name}</span>} value={day(tk_1.createdAt)} />;
}
function _temp0(x_0) {
  return x_0.revoked;
}
function _temp9(x) {
  return !x.revoked;
}
function _temp8() {
  return api.tokens.list();
}